'use client';

import { useEffect, useState } from 'react';
import styles from './StickyYoutubePlayer.module.scss';

const StickyYoutubePlayer = ({ videoId, time }: { videoId: string; time: string }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!visible) return null;

    return (
        <div
            className={`${styles.stickyPlayer} ${
                isMobile ? styles.mobile : styles.desktop
            }`}
        >
            <button
                className={styles.closeButton}
                onClick={() => setVisible(false)}
                aria-label="Close video"
            >
                ×
            </button>
            <div className={styles.videoWrapper}>
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&start=${time}&mute=1`}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="Sticky YouTube Video"
                ></iframe>
            </div>
        </div>
    );
};

export default StickyYoutubePlayer;
